import { SizeType } from '@config/type'
import cn from 'classnames'
import React from 'react'

import styles from './title.module.css'

interface TitleProps extends React.ComponentPropsWithoutRef<'h2'> {
  bold?: boolean
  size?: SizeType
  indent?: SizeType
  appearance?: 'inactive' | 'accent' | 'primary' | 'secondary' | 'inverse'
}

export const Title = ({
  className,
  bold = true,
  indent = 'sm',
  size = 'md',
  appearance = 'primary',
  children
}: TitleProps) => {
  return (
    <h2
      className={cn(styles.container, className, {
        [styles.bold]: bold,
        [styles.indentXs]: indent === 'xs',
        [styles.indentSm]: indent === 'sm',
        [styles.indentMd]: indent === 'md',
        [styles.indentLg]: indent === 'lg',
        [styles.indentXl]: indent === 'xl',
        [styles.xs]: size === 'xs',
        [styles.sm]: size === 'sm',
        [styles.md]: size === 'md',
        [styles.lg]: size === 'lg',
        [styles.xl]: size === 'xl',
        [styles.inactive]: appearance === 'inactive',
        [styles.accent]: appearance === 'accent',
        [styles.primary]: appearance === 'primary',
        [styles.secondary]: appearance === 'secondary',
        [styles.inverse]: appearance === 'inverse'
      })}
    >
      {children}
    </h2>
  )
}
